export const LoginPageDocuments = [
    {
        type: 'text',
        question_no: 'username',
        question: 'Username',
        description: '',
        depend_question: '',
        condition: 'equals',
        value: 'yes',
        validation: 'username',
        options: [],
        mandatory: 1,
    },
    {
        type: 'password',
        question_no: 'password',
        question: 'Password',
        description: '',
        depend_question: '',
        condition: 'equals',
        value: 'yes',
        validation: 'username',
        options: [],
        mandatory: 1,
    },
]
export const forgetPasswordDocuments = [
    {
        type: 'email',
        question_no: 'email',
        question: 'Email Address',
        description: '',
        depend_question: '',
        condition: 'equals',
        value: 'yes',
        validation: 'email',
        options: [],
        mandatory: 1,
    },

]
export const NewPasswordDocuments = [
    {
        type: 'text',
        question_no: 'password',
        question: 'New Password',
        description: '',
        depend_question: '',
        condition: 'equals',
        value: 'yes',
        validation: 'password',
        options: [],
        mandatory: 1,
    },
    {
        type: 'text',
        question_no: 'confirm_password',
        question: 'Confirm Password',
        description: '',
        depend_question: '',
        condition: 'equals',
        value: 'yes',
        validation: 'password',
        options: [],
        mandatory: 1,
    },

]